import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from 'views/App/context';
import { useTemplateDetailsContext } from '../../../_shared/Details/context';
import TemplateOutlineCard from '../../../_shared/_components/TemplateOutlineCard';
import { Template } from '../../../_shared/_types';

const TemplateOutline: React.FC = () => {
  const { currentOrganizationId, hasPermission } = useContext(AppContext);
  const { template, isLoading, isError } = useTemplateDetailsContext();
  const navigate = useNavigate();

  const canManageTemplates = hasPermission('manageFieldBank', currentOrganizationId || '');

  const handleEditTemplate = () => {
    if (!template) return;
    // Lexipol Admin: Always routes to the template builder (both active and draft templates)
    navigate(`../../builder/${template.id}`);
  };

  if (!template) {
    return null;
  }

  return (
    <TemplateOutlineCard
      template={template}
      onEditClick={handleEditTemplate}
      canManage={canManageTemplates}
      isLoading={isLoading}
      isError={isError}
    />
  );
};

export default TemplateOutline;

